import {postRequest, postRequestNoLoading, postRequestQrCode, postRequestQrCodeNoLoading} from 'utils/http';
import {BACKEND_API, BACKEND_API_BANNER, BACKEND_API_QR_CODE_MYVNPT} from 'global/environment';
import {v4 as uuidv4} from 'uuid';

const uuid = uuidv4()

const BASE_URL = BACKEND_API_QR_CODE_MYVNPT;

const setHeaders = () => {
  const Authorization = "Bearer a60bd62fed0cf1076e93af76114f196bd9c5a48155b2bac88afe15c49595414b";
  const setHeaders = {
    Authorization
  }
  return setHeaders;
};

const setRequest = () => {
  const data = {
    requestId: uuid
  }
  return data
}

export const QrCodeMyVNPTService = {

  getPackageInfo: function (data, successCallback, failCallback, hasLoading = true) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/getPackageInfo`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    if (hasLoading) {
      return postRequest(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    } else {
      return postRequestNoLoading(URL, dataHandle, {headers: setHeaders()}, successCallback, failCallback);
    }
  },

  getListNational: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/getListNational`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  createTransaction: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/createTransaction`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getQR: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/getQR`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  queryTransactionInfo: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/queryTransactionInfo`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCodeNoLoading(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  sendOtp: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API}/otp_send`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(
      URL, 
      dataHandle, 
      { headers: {
        ...setHeaders(), 
        "Device-Info": "03c5c3d3-db9a-45f1-bef9-4085d59b6ada|03c5c3d3-db9a-45f1-bef9-4085d59b6ada|unknown|Android|52:DD:4D:E3:C1:D1|3.2.93.Staging|CPH1931|10|52:DD:4D:E3:C1:D1",
      }},
      successCallback,
      failCallback
    );
  },

  irRegister: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_QR_CODE_MYVNPT}/irRegister`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },

  getListBannerByType: function (data, successCallback, failCallback) {
    const URL = `${BACKEND_API_BANNER}/getListBannerByType`;
    let request = setRequest()
    let dataHandle = {
      ...data,
      ...request
    }
    return postRequestQrCode(URL, dataHandle, { headers: setHeaders() }, successCallback, failCallback);
  },
};

